export const ADD_GRAFANA_DATASOURCE = 'ADD_GRAFANA_DATASOURCE'
export const ADD_GRAFANA_USER = 'ADD_GRAFANA_USER'
export const TOGGLE_GRAFANA_AUTO_ADD_USERS = 'TOGGLE_GRAFANA_AUTO_ADD_USERS'
